import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

var getGroups = function getGroups(groupBy, options) {
  return groupBy ? Array.from(new Set(options.map(function (item) {
    return groupBy(item);
  }))) : [""];
};

var getOptionsByGroup = function getOptionsByGroup(groupBy, groups, options) {
  return groups.map(function (group) {
    return {
      group: group,
      options: groupBy ? options.filter(function (item) {
        return groupBy(item) === group;
      }) : options
    };
  });
};

export { getGroups, getOptionsByGroup };